import { Component, OnInit } from '@angular/core';
import { getFromStorage } from '../../../helpers/storageUtils';
import { LeadResponse } from '../../../Models/leadResponse';


@Component({
  selector: 'app-details-vehicle-banner',
  templateUrl: './details-vehicle-banner.component.html',
  styleUrls: ['./details-vehicle-banner.component.scss'],
  standalone: true,
})
export class DetailsVehicleBannerComponent implements OnInit {

  dataVehicle: any = {};


  ngOnInit(): void {
    //const data = this.storageService.getLeadData();
      const leadResponse = getFromStorage<LeadResponse>('motosData', 'session');

      console.log('Data entrante', leadResponse);

      const response = leadResponse?.data;

      if (leadResponse) {
        // cast to VehicleOnerous if shapes are compatible
        this.dataVehicle = leadResponse;
      }


  }
}
